import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {FEEDBACK_API_ACTIONS, FeedbackModel} from 'src/app/models/feedback';
import {FEEDBACK_TABLE_TYPE} from 'src/app/models/feedback-table-config';
import {FeedbackService} from 'src/app/services/feedback.service';


@Component({
  selector: 'app-feedback-table',
  templateUrl: './feedback-table.component.html',
  styleUrls: ['./feedback-table.component.sass']
})
export class FeedbackTableComponent implements OnInit {
  @Input() public smartNumber = '';
  @Input() public feedbackTableType: FEEDBACK_TABLE_TYPE.ALL |
                                     FEEDBACK_TABLE_TYPE.ALL_ADMIN |
                                     FEEDBACK_TABLE_TYPE.ALL_CLIENT |
                                     FEEDBACK_TABLE_TYPE.BY_SN_CLIENT = FEEDBACK_TABLE_TYPE.ALL;

  public feedbackRecords$: Observable<FeedbackModel[]>;

  constructor(private feedbackService: FeedbackService) {
  }

  ngOnInit(): void {
    switch (this.feedbackTableType) {
      case FEEDBACK_TABLE_TYPE.BY_SN_CLIENT:
        this.feedbackRecords$ = this.feedbackService.getFeedbackBySn(this.smartNumber, FEEDBACK_API_ACTIONS.GET_CLIENT);
        break;
      case FEEDBACK_TABLE_TYPE.ALL_CLIENT:
        this.feedbackRecords$ = this.feedbackService.getFeedback(FEEDBACK_API_ACTIONS.GET_CLIENT);
        break;
      case FEEDBACK_TABLE_TYPE.ALL_ADMIN:
        this.feedbackRecords$ = this.feedbackService.getFeedback(FEEDBACK_API_ACTIONS.GET_ADMIN);
        break;
      case FEEDBACK_TABLE_TYPE.ALL:
        this.feedbackRecords$ = this.feedbackService.getFeedback(FEEDBACK_API_ACTIONS.GET_ALL_FEEDBACK);
        break;
    }
  }
}

